import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import Icon from '../../UI/Icon/Icon';

class InterviewAccordionItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: props.defaultActiveKey === props.accordionKey ? true : false
    };

    this.dynamicHeightHandling = this.dynamicHeightHandling.bind(this);
  }

  handleDocumentClick = event => {
    if (
      ReactDOM.findDOMNode(this).parentNode.contains(event.target) &&
      !ReactDOM.findDOMNode(this).contains(event.target) &&
      this.state.isExpanded
    ) {
      this.setState({ isExpanded: false });
    }
  };

  handleToggle = e => {
    e.preventDefault();
    this.setState({
      isExpanded: !this.state.isExpanded,
      // height: this.refs.inner.clientHeight
      height: "auto"
    });
  };

 
  dynamicHeightHandling = () => {
    this.setState({
      height: "auto"
    });
  };

  componentDidMount() {
    if (this.props.isAccordion) {
      document.addEventListener("click", this.handleDocumentClick, false);
      document.addEventListener("touchend", this.handleDocumentClick, false);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeCandidateId !== prevProps.activeCandidateId) {
      const isExpanded =
        this.props.defaultActiveKey === this.props.accordionKey ? true : false;
      this.setState({ isExpanded: isExpanded });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleDocumentClick, false);
    document.removeEventListener("touchend", this.handleDocumentClick, false);
  }

  render() {
    const { title, errorMsg, accordionKey,index,deleteModal,addInterviewee,children } = this.props;
    const { isExpanded, height } = this.state;
    const isExpandedClass = isExpanded ? "expanded" : "";
    const isExpandedIcon = isExpanded ? "up-accordion-icon" : "down-accordion-icon";
                            
    return (
      <div className="interview-accordion-main">
        <div id={accordionKey}
          className={`interview-accordion-panel 
                    ${isExpanded ? "is-expanded" : ""}`}          
        >
        {/* <div className="interview-details-header">
          <h1>{title}</h1>
          <span className ="add-interviewee-span"><Icon icon="add-icon" className ="add-interviewee-icon" onClick={this.handleAddInterviewee}/></span>
          </div> */}
          <div className="interview-accordion-panel-heading">
            <h1 className="interview__section_h1">
              {title}
              {errorMsg ? (
                <span className="form-error-message">{errorMsg}</span>
              ) : null}
            </h1>
            <span className="delete_interviewee-span">
              {<Icon icon={index<1? "" : "delete-icon"} className ="delete-interviewee-icon" onClick={index>0?deleteModal:""}/>}
            </span>
            <span className ="add-interviewee-span">
              {<Icon icon={index>0?isExpandedIcon:"add-icon"} className ={index>0?isExpandedIcon:"add-interviewee-icon"}  onClick={index>0?this.handleToggle:addInterviewee}/>}
            </span>            
          </div>
        </div>
        <div className={"interview-accordion-panel-collapse " + isExpandedClass}>
          <div
            className="interview-accordion-panel-body"
            onClick={this.dynamicHeightHandling}
            ref="inner"
          >
            {children}
          </div>
        </div>
      </div>
    );
  }
}

InterviewAccordionItem.propTypes = {
  title: PropTypes.string
};

export default InterviewAccordionItem;



// WEBPACK FOOTER //
// ./src/components/Recruiter/InterviewAccordion/InterviewAccordionItem.js